import React, { Component } from 'react'
import _ from 'lodash'
import cx from 'classnames'
import injectSheet from 'react-jss'
import styles from 'assets/styles/components/TakeawayOrderDetailList'
import { Flex, Modal } from 'antd-mobile'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { OrderDiscount } from 'models/order'
import helpers from 'helpers'
import { DELIVERY_TYPE_SHOP, DELIVERY_TYPE_STOREDELIVERY } from 'constants/merchant'
import CheckOutItemContainer from 'containers/components/CheckoutItem'
class TakeawayOrderDetailList extends Component {
  constructor (props) {
    super(props)
    this.state = {
      isCheckOutDetailCollapsed: true,
      isShippingDetailCollapsed: true,
      canCancelPromoCode: true,
      showCancelPromocodeAlert: false,
    }
  }

  async componentDidMount () {
    const path = this.props.history.location.pathname
    const isTakeawaySummary = path === '/basket/takeaway_summary'
    if (isTakeawaySummary) {
      let promocodes = []
      if (this.props.promocodes) {
        promocodes = this.props.promocodes.split(',')
      }
      if (promocodes.length) {
        const discounts = await this.props.redeemPromoCodes({ merchantId: this.props.merchant.id, promocodes })
        const results = _.chain(discounts)
          .filter(discount => {
            const { total } = helpers.calculate.calculateOrders(
              this.props.orders,
              this.props.merchant,
            )
            return total >= discount.data.minOrderAmount
          })
          .sortBy([
            discount => {
              const result = helpers.calculate.calculateOrders(
                this.props.orders,
                this.props.merchant,
                discount.data,
              )
              return result.discountedTotal
            },
          ])
          .value()
        if (results.length) {
          this.validatePromoCode(results[0].data.code)
        }
      }
    }
  }

  componentDidUpdate = (prevState) => {
    if (!prevState.showCancelPromocodeAlert && this.state.showCancelPromocodeAlert) {
      this.renderRemovePromocodeAlert()
    }
  }

  handleCollapseToggle = () => {
    this.setState({
      isCheckOutDetailCollapsed: !this.state.isCheckOutDetailCollapsed,
    })
  }

  renderTotalItem = (total) => {
    const {
      takeawayOrders,
      classes,
      intl,
      basket,
      takeawayWaitingBasket,
    } = this.props

    const _headerText = intl.formatMessage({ id: 'takeaway.summary.collapsed.header' })
    const _totalNumberText = intl.formatMessage({ id: basket.isShop ? 'takeaway.summary.total.number.shop' : 'takeaway.summary.total.number' })

    const headerStyle = cx(classes.header)
    const totalItemTitleStyle = cx(classes['total-item-title'])
    const itemPricePrefixStyle = cx(classes['item-price-prefix'])
    const itemPriceStyle = cx(classes['item-price'])
    const discountedItemPriceStyle = cx(classes['discounted-item-original-price'])

    let discountedTotalDiv
    if (!_.isEmpty(takeawayWaitingBasket)) {
      if (_.get(takeawayWaitingBasket, 'discount.percent') > 0 || _.get(takeawayWaitingBasket, 'discount.amount') > 0) {
        discountedTotalDiv = (
          <div>
            <span className={discountedItemPriceStyle}>
              <FontAwesomeIcon icon='dollar-sign' />
              {takeawayWaitingBasket.originalTotal}
            </span>
            <span className={itemPricePrefixStyle}>
              <FontAwesomeIcon icon='dollar-sign' />
            </span>
            <span className={itemPriceStyle}>
              {takeawayWaitingBasket.paidAmount}
            </span>
          </div>
        )
      } else {
        discountedTotalDiv = (
          <div>
            <span className={itemPricePrefixStyle}>
              <FontAwesomeIcon icon='dollar-sign' />
            </span>
            <span className={itemPriceStyle}>
              {takeawayWaitingBasket.paidAmount}
            </span>
          </div>)
      }
    } else { // use basket
      const { basket, merchant, orders } = this.props

      const {
        discountedTotal,
        total,
      } = helpers.calculate.calculateOrders(
        orders,
        merchant,
        _.get(basket, 'discount'),
      )

      if (discountedTotal !== total) {
        discountedTotalDiv = (
          <div>
            <span className={discountedItemPriceStyle}>
              <FontAwesomeIcon icon='dollar-sign' />{total}
            </span>
            <span className={itemPricePrefixStyle}>
              <FontAwesomeIcon icon='dollar-sign' />
            </span>
            <span className={itemPriceStyle}>
              {discountedTotal}
            </span>
          </div>
        )
      } else {
        discountedTotalDiv = (
          <div>
            <span className={itemPricePrefixStyle}>
              <FontAwesomeIcon icon='dollar-sign' />
            </span>
            <span className={itemPriceStyle}>
              {total}
            </span>
          </div>)
      }
    }

    return (
      <Flex style={{ flex: 1 }}>
        <Flex.Item>
          <div className={headerStyle}>{_headerText}</div>
          <div className={totalItemTitleStyle}>
            {takeawayOrders.reduce((prev, curr) => { return curr.quantity + prev }, 0)}
            {_totalNumberText}
            {/* 份 餐單 */}
          </div>
        </Flex.Item>

        <Flex.Item align='right'>
          {discountedTotalDiv}
        </Flex.Item>
      </Flex>
    )
  }

  validatePromoCode = async (promoCode) => {
    const { intl, onPromoCodeValueChanged, merchant, redeemPromoCode, onPromoCodeFailed } = this.props
    const result = await redeemPromoCode({ merchantId: merchant.id, promoCode: promoCode })
    if (!_.get(result, 'success')) {
      const invalidCodeText = intl.formatMessage({ id: 'takeaway.order.promo.code.invalid' })
      onPromoCodeFailed(invalidCodeText)
    } else {
      const { total } = helpers.calculate.calculateOrders(
        this.props.orders,
        this.props.merchant,
      )
      if (total < result.data.minOrderAmount) {
        this.props.removePromoCode()
        onPromoCodeFailed(intl.formatMessage(
          { id: 'toast.promocode.lessThanMinOrderAmount' },
          { amt: result.data.minOrderAmount }))
      }
    }
    onPromoCodeValueChanged('')
    this.setState({ canCancelPromoCode: false })
    setTimeout(() => { this.setState({ canCancelPromoCode: true }) }, 500)
  }

  removePromoCode = () => {
    const { removePromoCode } = this.props
    removePromoCode()
    this.setState({ canCancelPromoCode: false })
  }

  renderRemovePromocodeAlert = () => {
    const { intl } = this.props
    const goBackButtonText = intl.formatMessage({ id: 'dialog.go_back' })
    const confirmButtonText = intl.formatMessage({ id: 'dialog.confirm_btn' })
    const removePromocodeTitle = intl.formatMessage({ id: 'dialog.promocode.removePromocode' })
    const removePromocodeMessage = intl.formatMessage({ id: 'dialog.promocode.removePromocode.message' })

    const title = removePromocodeTitle
    const message = removePromocodeMessage
    // buttons
    const goBackButton = {
      text: goBackButtonText,
      onPress: () => {
        this.setState({ showCancelPromocodeAlert: false })
      },
    }
    const confirmButton = {
      text: confirmButtonText,
      onPress: () => {
        if (this.state.canCancelPromoCode) {
          this.removePromoCode()
          this.setState({ showCancelPromocodeAlert: false })
        }
      },
    }
    const alertButtons = [goBackButton, confirmButton]
    Modal.alert(title, message, alertButtons)
  }

  render () {
    const {
      takeawayOrders,
      classes,
      intl,
      basket,
      takeawayPaymentMethod,
      promoCode,
      promoCodeInput,
      onPromoCodeValueChanged,
      history,
      orders,
      // merchant,
      address,
    } = this.props

    if (!takeawayOrders) return <div></div>

    const _expandButtonText = intl.formatMessage({ id: 'takeaway.toggle.button.title' })
    const _collapsButtonText = intl.formatMessage({ id: 'takeaway.toggle.button.title.hide' })
    const _checkOutDetailbuttonText = this.state.isCheckOutDetailCollapsed ? _expandButtonText : _collapsButtonText
    // const _shippingDetailButtonText = this.state.isShippingDetailCollapsed ? _expandButtonText : _collapsButtonText
    const _promoCodeText = intl.formatMessage({ id: 'takeaway.order.promo.code' })
    const _memberPromoText = intl.formatMessage({ id: 'takeaway.order.promo.memberpromo' })
    const _promoCodeSubmitText = intl.formatMessage({ id: 'takeaway.order.promo.code.submit' })
    const _promoCodeCancelText = intl.formatMessage({ id: 'takeaway.order.promo.code.cancel' })
    const _shippingfeeText = intl.formatMessage({ id: 'shipping.shipping_fee' })
    const _shippingfeeFreeText = intl.formatMessage({ id: 'shipping.free_shipping' })
    const _freightCollectText = intl.formatMessage({ id: 'shipping.freight_collect' })
    const _paymentMethodText = takeawayPaymentMethod ? intl.formatMessage({ id: 'checkout.method.' + takeawayPaymentMethod }) : ''
    const _pleaseSelectShippingText = intl.formatMessage({ id: 'shipping.please_select_shipping' })
    // const _shippingServiceText = intl.formatMessage({ id: 'shipping.shipping_service' })

    const containerStyle = cx(classes['takeaway-order-detail-list-wrap'])
    const promoCodeSpanStyle = cx(classes['promo-code-span'])
    // const subHeaderStyle = cx(classes['takeaway-summary-sub-header'])
    const buttonStyle = cx(classes['collapse-toggle'])
    const collapsedToggleWrapStyle = cx(classes['collapse-toggle-wrap'])
    const expandToggleWrapStyle = cx(classes['expand-toggle-wrap'])
    const promoCodeInputStyle = cx(classes['promo-code-input'])
    const promoCodeCancelStyle = cx(classes['promo-code-button'], classes['promo-code-cancel'])
    const promoCodeSubmitEnabledStyle = cx(classes['promo-code-button'], classes['promo-code-submit-enabled'])
    const promoCodeSubmitDisabledStyle = cx(classes['promo-code-button'], classes['promo-code-submit-disabled'])
    const promoCodeSubmitStyle = (promoCodeInput && promoCodeInput.length) > 0 ? promoCodeSubmitEnabledStyle : promoCodeSubmitDisabledStyle
    const itemPricePrefixStyle = cx(classes['item-price-prefix'])
    const itemPriceStyle = cx(classes['item-price'])
    const itemPriceDisabledStyle = cx(classes['item-price-disabled'])
    const paymentMethodSpanStyle = cx(classes['payment-mathod-span'])

    const isTakeawayWaiting = history.location.pathname.indexOf('/basket/takeaway_waiting') > -1

    let orderDetail
    let couponItem

    const discount = new OrderDiscount(basket.discount)
    if (promoCode && !discount.isEmpty()) {
      let cancelBtn
      if (!isTakeawayWaiting) {
        cancelBtn = (
          <span
            className={promoCodeCancelStyle}
            onClick={() => this.setState({ showCancelPromocodeAlert: true })}
          >
            {_promoCodeCancelText}
          </span>
        )
      }

      if (basket.discount.percent > 0 || basket.discount.amount > 0) {
        couponItem = (
          <div className={containerStyle}>
            <span className={promoCodeSpanStyle} style={{ flex: 1 }}>
              {`${_promoCodeText}\n[${promoCode}]`}
            </span>
            {cancelBtn}
          </div>
        )
      }
    } else if (_.get(basket.discount, 'amount')) {
      // discount without promocode
      couponItem = (
        <div className={containerStyle}>
          <span className={promoCodeSpanStyle} style={{ flex: 1 }}>
            {`${_promoCodeText}\n${{ _memberPromoText }}`}
          </span>
        </div>
      )
    } else if (history.location.pathname.indexOf('takeaway_summary') > -1) {
      couponItem = (
        <div className={containerStyle}>
          <span className={promoCodeSpanStyle}>
            {_promoCodeText}
          </span>
          <input
            className={promoCodeInputStyle}
            maxLength='8'
            onChange={(e) => onPromoCodeValueChanged(e.target.value)}
            value={promoCodeInput}
          />
          <span
            className={promoCodeSubmitStyle}
            onClick={() => {
              if (promoCodeInput && promoCodeInput.length > 0) {
                this.validatePromoCode(promoCodeInput)
              }
            }}
          >
            {_promoCodeSubmitText}
          </span>
        </div>)
    }

    // > Shipping Fee
    const renderShippingFee = () => {
      const { classes, takeawayWaitingBasket, selectedShipping, deliveryType, merchant, basket, orders } = this.props
      // const shippingDetailWrapStyle = cx(classes['shipping-detail-wrap'])
      const shippingFeeWrapStyle = cx(classes['shipping-fee-wrap'])

      const shipping = basket.shipping || selectedShipping || takeawayWaitingBasket.shipping
      // const address = this.props.address || takeawayWaitingBasket.address

      if (
        deliveryType === DELIVERY_TYPE_SHOP ||
        deliveryType === DELIVERY_TYPE_STOREDELIVERY ||
        takeawayWaitingBasket.deliveryType === DELIVERY_TYPE_SHOP ||
        takeawayWaitingBasket.deliveryType === DELIVERY_TYPE_STOREDELIVERY
      ) {
        const renderFreightPaymentType = () => {
          // prepaid or collect
          if (shipping) {
            if (shipping.freightCollect && shipping.cost !== 0) {
              return <span>{_freightCollectText}</span>
            } else {
              return <span>{_shippingfeeText}</span>
            }
          }
        }

        const renderFreight = () => {
          // has discount, no discount, free shiping, no selected shipping.
          const {
            discountedShippingFee,
            shippingDiscount,
          } = helpers.calculate.calculateOrders(
            _.get(takeawayWaitingBasket, 'batches', orders),
            merchant,
            _.get(basket, 'discount'),
            shipping,
          )

          if (shipping) {
            if (shipping.totalFee > 0) {
              return (
                <div>
                  {shippingDiscount > 0 && (
                    <span className={cx(classes['discounted-item-original-price'])}>
                      <FontAwesomeIcon icon='dollar-sign' />
                      {shipping.totalFee}
                    </span>
                  )}
                  <span className={itemPricePrefixStyle}>
                    <FontAwesomeIcon icon='dollar-sign' />
                  </span>
                  <span className={itemPriceStyle}>
                    {discountedShippingFee}
                  </span>
                </div>
              )
            } else {
              // freight collect
              if (shipping.freightCollect) {
                return (
                  <span className={itemPriceStyle}>
                    {_freightCollectText}
                  </span>
                )
              }
              // free shipping
              return (
                <span className={itemPriceStyle}>
                  {_shippingfeeFreeText}
                </span>
              )
            }
          } else {
            // no selected shipping
            return (
              <span
                className={itemPriceDisabledStyle}
                style={{ flex: 1, textAlign: 'center' }}
              >
                {_pleaseSelectShippingText}
              </span>
            )
          }
        }

        return (
          <div
            className={containerStyle}
            style={{ flexDirection: 'column', justifyContent: 'center' }}
          >

            {/* Shipping Fee */}
            <div className={shippingFeeWrapStyle}>
              {renderFreightPaymentType()}
              {renderFreight()}
            </div>

            {/* Shipping Details */}
            {/* {shipping && !this.state.isShippingDetailCollapsed && (
              <div className={shippingDetailWrapStyle}>
                <div className={subHeaderStyle}>{`${_shippingServiceText}:`}</div>
                <div>{`${shipping.name}($${shipping.cost})`}</div>
                <div className={subHeaderStyle}>地址:</div>
                <div>{address}</div>
              </div>
            )} */}

            {/* Expand/Collaps Button */}
            {/* {shipping && (
              <div
                className={buttonStyle}
                style={{ position: 'absolute', bottom: -12 }}
                onClick={() => this.setState({ isShippingDetailCollapsed: !this.state.isShippingDetailCollapsed })}
              >
                {_shippingDetailButtonText}
              </div>
            )} */}

          </div>
        )
      }
    }

    if (this.state.isCheckOutDetailCollapsed) {
      orderDetail = (
        <React.Fragment>
          <div
            className={containerStyle}
            style={{ height: (_paymentMethodText ? 42 : 32) + 'px' }}
          >
            {this.renderTotalItem()}
            {_paymentMethodText && <span className={paymentMethodSpanStyle}>{_paymentMethodText}</span>}

            <Flex
              justify='center'
              className={collapsedToggleWrapStyle}
              onClick={this.handleCollapseToggle}
            >
              <div className={buttonStyle}>
                {_checkOutDetailbuttonText}
              </div>
            </Flex>
          </div>
        </React.Fragment>
      )
    } else { // 展開
      const paymentMethod = <span className={paymentMethodSpanStyle}>{_paymentMethodText}</span>
      const remarks = {}
      orders.forEach((ele, index) => {
        remarks[index] = ele.remarks
      })

      orderDetail = (
        <React.Fragment>
          <div style={{ marginLeft: '15px', marginRight: '15px' }}>
            <CheckOutItemContainer
              paymentMethod={paymentMethod}
              selectedRemarkItems={remarks}
              bottomEle={this.renderTotalItem()}
              isTakeaway
              hideRemarkField
              basket={basket}
              isHistory={false}
              list={takeawayOrders}
            />
            <Flex
              justify='center'
              className={expandToggleWrapStyle}
              onClick={this.handleCollapseToggle}
            >
              <div className={buttonStyle}>
                {_checkOutDetailbuttonText}
              </div>
            </Flex>
          </div>
        </React.Fragment>
      )
    }

    const tnc = (
      <div className={cx(classes.tncWrap)}>
        <div className={cx(classes.tnc)}>
          <p>
            {intl.formatMessage({ id: 'tnc.line1' })}
            <a
              className={cx(classes.tncLink)}
              rel="noopener noreferrer"
              target="_blank"
              href="https://www.dimorder.com/tnc"
            >
              {intl.formatMessage({ id: 'tnc.linkText' })}
            </a>
            {intl.formatMessage({ id: 'tnc.line1AfterLink' })}
          </p>
          {/* <p>
            {intl.formatMessage({ id: 'tnc.line2' })}
          </p> */}
        </div>
      </div>
    )
    let b = basket
    if (!_.isEmpty(this.props.parentBasket)) {
      b = this.props.parentBasket
    }
    const showShippingFee = (b.status === 'paid' && b.shipping) || (address && b.shipping)

    return (
      <React.Fragment>
        {couponItem}
        {showShippingFee && renderShippingFee()}
        {orderDetail}
        { !isTakeawayWaiting && tnc }
      </React.Fragment>
    )
  }
}

export default injectSheet(styles)(TakeawayOrderDetailList)



// WEBPACK FOOTER //
// ./src/components/TakeawayOrderDetailList.js